import { LegacyCard, Page, Layout, Link, TextContainer, Text } from '@shopify/polaris';
import React, { useState, useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { deleteCustomer, getCustomer } from '../../../services/customersService';
import ListOrders from '../../UI/Customers/ListOrders';
import { EditCustomerModal } from '../../UI/Customers/EditCustomerModal';
import ViewCustomerPrimaryActions from '../../UI/Customers/ViewCustomerPrimaryActions';
import { EditCommerceRelationModal } from '../../UI/Customers/EditCommerceRelationModal';

const CustomersProfile = () => {
  const { id } = useParams();
  const history = useHistory();
  const [customer, setCustomer] = useState(false);

  const returnMatch = window.location.search.match(/\??r=(.+)&?/);
  const returnUrl = returnMatch && returnMatch.length > 1 ? window.atob(returnMatch[1]) : '/customers';

  useEffect(() => {
    getCustomer(id).then(({ data }) => setCustomer(data));
    // eslint-disable-next-line
  }, []);

  const [active, setActive] = useState(false);
  const [activePvfModal, setActivePvfactivePvfModal] = useState(false);

  const handleEditCustomer = () => setActive(true);
  const handleEditRelation = () => setActivePvfactivePvfModal(true);
  const handleDelete = () => {
    deleteCustomer(id);
    history.push(returnUrl);
  };

  return customer && (
    <Page
      title={customer.name}
      subtitle={`${customer.city}, ${customer.state}, ${customer.country} · Cliente desde ${
        customer.createdAt &&
        Intl.DateTimeFormat('es-mx', {
          year: 'numeric',
          month: 'long',
          day: 'numeric',
        }).format(new Date(customer.createdAt))
      }`}
      primaryAction={
        <ViewCustomerPrimaryActions
          customer={customer}
          onEditCustomer={handleEditCustomer}
          onEditRelation={handleEditRelation}
          onDelete={handleDelete}
        />
      }
      backAction={{ content: 'Ver clientes', url: returnUrl }}
      divider
    >
      <Layout>
        <Layout.Section>
          <LegacyCard title="Últimos pedidos">
            <LegacyCard.Section>
              <ListOrders customerId={id} />
            </LegacyCard.Section>
          </LegacyCard>
        </Layout.Section>

        <Layout.Section secondary>
          <LegacyCard
            title="Cliente"
            actions={[
              {
                content: 'Editar',
                onAction: () => setActive(true),
              },
            ]}>
            <LegacyCard.Section>
              <TextContainer>
                <Text>
                  <Link external={true} url={`mailto:${customer.email}`}>
                    {customer.email}
                  </Link>
                </Text>
                <Text>Tel: {customer.phone}</Text>
              </TextContainer>
            </LegacyCard.Section>
            <LegacyCard.Section>
              <Text fontWeight="medium">{customer.name}</Text>
              <Text>RFC: {customer.vat}</Text>
            </LegacyCard.Section>
            <LegacyCard.Section title="Dirección Fiscal">
              <TextContainer>
                <p>
                  <span className="text-bold">{customer.address}</span>
                  <br />
                  {customer.zip} - {customer.city}
                  <br />
                  {customer.state} ({customer.country})
                </p>
              </TextContainer>
            </LegacyCard.Section>
          </LegacyCard>

          <LegacyCard title="Pedidos facturados">
            <LegacyCard.Section>
              <Text variant="bodyMd" as="p" color="subdued">
                Cantidad de pedidos
              </Text>
              <Text variant="headingLg" as="p" fontWeight="semiBold">
                {customer.sells.totalOrders}
              </Text>
            </LegacyCard.Section>
            <LegacyCard.Section>
              <Text variant="bodyMd" as="p" color="subdued">
                Total stock servido
              </Text>
              <Text variant="headingLg" as="p" fontWeight="semiBold">
                {customer.sells.totalStock}
              </Text>
            </LegacyCard.Section>
            <LegacyCard.Section>
              <Text variant="bodyMd" as="p" color="subdued">
                Total Facturado PVF
              </Text>
              <Text variant="headingLg" as="p" fontWeight="semiBold">
                {Intl.NumberFormat('es-mx', {
                  style: 'currency',
                  currency: 'MXN',
                }).format(customer.sells.totalValue)}{' '}
                MXN
              </Text>
            </LegacyCard.Section>
          </LegacyCard>
        </Layout.Section>
      </Layout>
      {active && (
        <EditCustomerModal
          active={active}
          customer={customer}
          id={id}
          onSave={(c) => setCustomer({ ...customer, ...c })}
          onClose={() => setActive(false)}
        />
      )}

      {activePvfModal && (
        // eslint-disable-next-line react/jsx-no-undef
        <EditCommerceRelationModal
          active={activePvfModal}
          customer={customer}
          id={id}
          onSave={(c) => setCustomer({ ...customer, ...c })}
          onClose={() => setActivePvfactivePvfModal(false)}
        />
      )}
    </Page>
  );
};

export default CustomersProfile;
